import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
const initialState = {
  dateFilter: {
    startDate1: null,
    endDate1: null,
    startDate2: null,
    endDate2: null,
  },
  dateGrouping: "day",
  typeGrouping: "product",
  areaGrouping: "shop",
  promotionGrouping: "shop",
  selectedPromotionTarget: null,
  selectedProduct: [],
  selectedAm: [],
  selectedBrand: [],
  selectedMode: ["all"],
  selectedSource: ["promoter_actual", "promoter_actual"],
  compareOption: null,
  comparisonSettings: [],
  savedFilter: {},
  combineSameSku: true,
};

export const restoreSettings = createAsyncThunk(
  "dataTable/restoreSettings",
  async () => {
    const storage = window.localStorage;
    let comparisonSettings = [];
    let filters = null;
    const comparisonSettingsStorage = storage.getItem("comparisonSettings");
    const filtersStorage = storage.getItem("filters");

    if (comparisonSettingsStorage) {
      comparisonSettings = JSON.parse(comparisonSettingsStorage);
    }

    if (filtersStorage) {
      filters = JSON.parse(filtersStorage);
      _.forEach(filters["/compareSales"], (f, index) => {
        if (f.selectedSource) {
          if (f.typeGrouping === "shop") {
            if (f.selectedSource[0] === "all") {
              filters["/compareSales"][index]["selectedSource"][0] =
                "promoter_actual";
            } else {
              filters["/compareSales"][index]["selectedSource"][0] =
                "promoter_report";
            }
            if (f.selectedSource[1] === "all") {
              filters["/compareSales"][index]["selectedSource"][1] =
                "promoter_actual";
            } else {
              filters["/compareSales"][index]["selectedSource"][1] =
                "promoter_report";
            }
          } else {
            if (f.selectedSource[0] === "all") {
              filters["/compareSales"][index]["selectedSource"][0] =
                "all_actual";
            } else {
              filters["/compareSales"][index]["selectedSource"][0] =
                "promoter_actual";
            }
            if (f.selectedSource[1] === "all") {
              filters["/compareSales"][index]["selectedSource"][1] =
                "all_actual";
            } else {
              filters["/compareSales"][index]["selectedSource"][1] =
                "promoter_actual";
            }
          }
        }
      });
      storage.setItem("filters", JSON.stringify(filters));
    }
    let savedFilter = {};
    if (_.isArray(comparisonSettings) && !filters) {
      savedFilter = {
        "/compareSales": comparisonSettings,
      };
    } else {
      savedFilter = filters;
    }

    return { savedFilter };
  }
);

export const removeFilter = createAsyncThunk(
  "dataTable/removeFilter",
  async ({ id, pathname }, { getState }) => {
    const storage = window.localStorage;

    const allFilter = { ...getState().dataTable.savedFilter };
    const currentFilters = getState().dataTable.savedFilter[pathname];

    const removed = _.filter(
      currentFilters,
      (currentFilter) => currentFilter.id !== id
    );
    allFilter[pathname] = removed;
    storage.setItem("filters", JSON.stringify(allFilter));

    return { newfilter: allFilter };
  }
);
export const restoreFilter = createAsyncThunk(
  "dataTable/restoreFilter",
  async ({ id, pathname }, { getState }) => {
    const currentFilters = getState().dataTable.savedFilter[pathname];
    const selectedFilter = _.filter(
      currentFilters,
      (currentFilter) => currentFilter.id === id
    );
    return { selectedFilter: selectedFilter[0] };
  }
);

export const saveFilter = createAsyncThunk(
  "dataTable/saveFilter",
  async (arg, { getState }) => {
    const { name, visableColumns, pathname } = arg;
    const storage = window.localStorage;
    const {
      dateGrouping,
      typeGrouping,
      selectedProduct,
      selectedBrand,
      dateFilter,
      combineSameSku,
      selectedSource,
      compareOption,
    } = getState().dataTable;
    const allFilter = { ...getState().dataTable.savedFilter };
    const currentFilter = getState().dataTable.savedFilter[pathname] ?? [];
    const newfilter = _.concat(currentFilter, {
      id: currentFilter.length + 1,
      name,
      dateGrouping,
      typeGrouping,
      selectedProduct,
      selectedBrand,
      dateFilter,
      combineSameSku,
      visableColumns,
      selectedSource,
      compareOption,
    });
    allFilter[pathname] = newfilter;
    storage.setItem("filters", JSON.stringify(allFilter));
    return { allFilter };
  }
);
export const dataTableSlice = createSlice({
  name: "dataTable",
  initialState,
  reducers: {
    setSelectedPromotionTarget: (state, action) => {
      const { value } = action.payload;
      state.selectedPromotionTarget = value;
    },
    setSelectedAm: (state, action) => {
      const { value } = action.payload;
      state.selectedAm = value;
    },
    setSelectedProduct: (state, action) => {
      const { value } = action.payload;
      state.selectedProduct = value;
    },
    setSelectedBrand: (state, action) => {
      const { value } = action.payload;
      state.selectedBrand = value;
    },
    setDateFilter: (state, action) => {
      const { field, value } = action.payload;
      state.dateFilter[field] = value;
    },
    setDateGrouping: (state, action) => {
      const { value } = action.payload;
      state.dateGrouping = value;
    },
    setCompareOption: (state, action) => {
      const { value } = action.payload;
      state.compareOption = value;
    },
    setSelectedMode: (state, action) => {
      const { value } = action.payload;
      state.selectedMode = value;
    },
    setSelectedSource: (state, action) => {
      const { value, index } = action.payload;
      state.selectedSource[index] = value;
    },
    setTypeGrouping: (state, action) => {
      const { value } = action.payload;
      state.typeGrouping = value;
    },
    setAreaGrouping: (state, action) => {
      const { value } = action.payload;
      state.areaGrouping = value;
    },
    setPromotionGrouping: (state, action) => {
      const { value } = action.payload;
      state.promotionGrouping = value;
    },
    resetCompareDate: (state, action) => {
      state.dateFilter.startDate2 = null;
      state.dateFilter.endDate2 = null;
    },
    setFilter: (state, action) => {
      state.dateGrouping = action.payload.dateGrouping;
      state.dateFilter = action.payload.dateFilter;
      state.selectedProduct = action.payload.selectedProduct;
      state.typeGrouping = action.payload.typeGrouping;
      state.combineSameSku = action.payload.combineSameSku;
      state.selectedSource = action.payload.selectedSource;
      state.compareOption = action.payload.compareOption;
      state.areaGrouping = action.payload.areaGrouping;
    },
    swapFilter: (state, action) => {
      const { startDate2, startDate1, endDate1, endDate2 } = state.dateFilter;
      state.dateFilter.startDate2 = startDate1;
      state.dateFilter.endDate2 = endDate1;
      state.dateFilter.startDate1 = startDate2;
      state.dateFilter.endDate1 = endDate2;
    },
    setCombineSameSku: (state) => {
      state.combineSameSku = !state.combineSameSku;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveFilter.fulfilled, (state, action) => {
        const { allFilter } = action.payload;
        state.savedFilter = allFilter;
      })
      .addCase(restoreSettings.fulfilled, (state, action) => {
        const { savedFilter } = action.payload;
        state.savedFilter = savedFilter;
      })
      .addCase(removeFilter.fulfilled, (state, action) => {
        const { newfilter } = action.payload;
        state.savedFilter = newfilter;
      })
      .addCase(restoreFilter.fulfilled, (state, action) => {
        const { selectedFilter } = action.payload;
        state.dateGrouping = selectedFilter.dateGrouping;
        state.dateFilter = selectedFilter.dateFilter;
        state.selectedProduct = selectedFilter.selectedProduct;
        state.selectedBrand = selectedFilter.selectedBrand;
        state.typeGrouping = selectedFilter.typeGrouping;
        state.combineSameSku = selectedFilter.combineSameSku;
        state.selectedSource =
          selectedFilter.selectedSource ?? initialState.selectedSource;
        state.compareOption = selectedFilter.compareOption;
      });
  },
});

// Action creators are generated for each case reducer function
export const {
  setSelectedPromotionTarget,
  setPromotionGrouping,
  setSelectedAm,
  setSelectedProduct,
  setSelectedSource,
  setSelectedMode,
  setCompareOption,
  setSelectedBrand,
  setDateFilter,
  setTypeGrouping,
  setAreaGrouping,
  setDateGrouping,
  resetCompareDate,
  swapFilter,
  setFilter,
  setCombineSameSku,
} = dataTableSlice.actions;

export default dataTableSlice.reducer;
